import { SummaryTemplatesPage } from '@/views/summary-templates/summary-templates-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/templates')({
  component: RouteComponent,
});

function RouteComponent() {
  return <SummaryTemplatesPage />;
}
